import { useState, useEffect, useCallback } from 'react';
import { getAccountBillingStatus } from '../lib/api';

/**
 * Single source of truth for the logged-in ACCOUNT's commercial access.
 *
 * `has_access` is computed by the backend central resolver (entitlements.py).
 * The frontend consumes it directly and never re-implements status rules like
 * `status === 'trialing' || status === 'active'`. `status` is presentation-only.
 */
export function useAccountAccess() {
  const [state, setState] = useState({
    loading: true,
    hasAccess: false,
    status: null,
    currentPeriodEnd: null,
    cancelAtPeriodEnd: false,
    entitlement: null,
  });

  const refresh = useCallback(async () => {
    setState((s) => ({ ...s, loading: true }));
    try {
      const res = await getAccountBillingStatus();
      const d = res.data || {};
      setState({
        loading: false,
        hasAccess: !!d.has_access,
        status: d.status || null,
        currentPeriodEnd: d.current_period_end || null,
        cancelAtPeriodEnd: !!d.cancel_at_period_end,
        entitlement: d.entitlement || null,
      });
      return d;
    } catch {
      setState((s) => ({ ...s, loading: false }));
      return null;
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { ...state, refresh };
}
